import { Button } from "@drs-ops/ui";
import type React from "react";
import { useAuth } from "@/auth";

export function SignIn(): React.ReactElement {
  const { login, isLoading } = useAuth();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex max-w-sm flex-col items-center gap-4 rounded-lg border border-border bg-card p-8 text-center shadow-sm">
        <h1 className="text-xl font-semibold">DRS Estimator</h1>
        <p className="text-sm text-muted-foreground">Sign in with your DRS Microsoft 365 account to continue.</p>
        <Button type="button" disabled={isLoading} onClick={() => void login()}>
          Sign in with Microsoft
        </Button>
      </div>
    </div>
  );
}
